import { Icon } from "@iconify/react";
import { Container, SectionHeading } from "./primitives";

const TESTIMONIALS = [
  {
    quote: "I've had records scattered across four hospitals for twelve years. MedSyncIQ organized all of it in a weekend. I actually understand my own health now.",
    initials: "MT", name: "Maria T.", role: "Managing Type 2 Diabetes, Chicago IL",
  },
  {
    quote: "The AI verification piece is what won our clinical team over. We needed confidence that AI extractions wouldn't reach patients unchecked. They engineered exactly that.",
    initials: "DAP", name: "Dr. Anita Patel", role: "Chief Medical Information Officer, Northside Health System",
  },
];

export function TestimonialsSection() {
  return (
    <section className="bg-[#F8F9FB] pt-[88px] pb-20 lg:pt-[110px] lg:pb-[100px]">
      <Container>
        <SectionHeading eyebrow="What people are saying" title="Trusted by patients and clinicians" />

        <div className="mx-auto mt-14 grid max-w-[792px] gap-[27px] md:grid-cols-2">
          {TESTIMONIALS.map(t => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-[#E8E9EE] bg-white px-7 pt-[33px] pb-[30px]">
              <div className="flex gap-[5px]" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }, (_, i) => (
                  <Icon key={i} icon="lucide:star" className="h-[13px] w-[13px] text-[#F18095] [&_path]:fill-current" />
                ))}
              </div>
              <blockquote className="!mt-5 text-[15.5px] italic leading-[27px] text-[#374151]">"{t.quote}"</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-8">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#120240] text-[13px] font-bold text-white">
                  {t.initials}
                </span>
                <span>
                  <span className="block text-[14.5px] font-bold text-[#120240]">{t.name}</span>
                  <span className="block text-[12px] leading-[18px] text-[#9CA3AF]">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Container>
    </section>
  );
}
